import { INominationLimitQuery } from '@/app/core/interfaces/nomination-limit.interface';

export class LoadNominationLimitDataAction {
  static readonly type = '[NominationLimit] Load Nomination Limit Data';
  constructor(public query?: INominationLimitQuery) {}
}

export class LoadNominationLimitOptionsAction {
  static readonly type = '[NominationLimit] Load Nomination Limit Options';
}

export class ClearNominationLimitDataAction {
  static readonly type = '[NominationLimit] Clear Nomination Limit Data';
}


